import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import IndividualChickenView from '../components/IndividualChickenView/IndividualChickenView';
import DucksIndividualView from '../components/DucksIndividualView/DucksIndividualView';

const Home = lazy(() => import('../pages/Home/Home'));
const About = lazy(() => import('../pages/About/About'));
const Chickens = lazy(() => import('../pages/Chickens/Chickens'));
const Ducks = lazy(() => import('../pages/Ducks/Ducks'));
const Contact = lazy(() => import('../pages/Contact/Contact'));
const NotFound = lazy(() => import('../pages/NotFound/NotFound'));

const AppRoutes: React.FC = () => {
    return (
        <Router>
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/chickens" element={<Chickens />} />
                    <Route path="/chickens/:name" element={<IndividualChickenView />} />
                    <Route path="/ducks" element={<Ducks />} />
                    <Route path="/ducks/:name" element={<DucksIndividualView />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/home" element={<Navigate to="/" replace />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </Router>
    );
};

export default AppRoutes;
